import script from "./terminal-detail-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./terminal-detail-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./terminal-detail-drawer.vue?vue&type=style&index=0&id=d1d0bab0&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1d0bab0"]])

export default __exports__